/* unplugin-vue-components disabled */import { render } from "./DeviceUnique.vue?vue&type=template&id=10680e0f&scoped=true"
import script from "./DeviceUnique.vue?vue&type=script&lang=js"
export * from "./DeviceUnique.vue?vue&type=script&lang=js"

import "./DeviceUnique.vue?vue&type=style&index=0&id=10680e0f&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10680e0f"]])

export default __exports__